import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

const EDITEUR = {
  nom: "ETOUNDI Thomas",
  forme: "entrepreneur individuel",
  siren: "844 947 697",
  siret: "844 947 697 00018",
  adresse: "10 rue des Sorbiers, 86440 Migné-Auxances",
  email: "thomasfrancis86000@gmail.com",
};

function LegalLayout({ title, children, testid }) {
  return (
    <div className="min-h-screen bg-[#F7F4EE]" data-testid={testid}>
      <header className="bg-[#12100D] px-5 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <Logo size={32} iconSize={17} />
            <span className="font-serif font-semibold text-white">Mastoras</span>
          </div>
          <Link to="/" className="text-stone-400 hover:text-white text-sm flex items-center gap-1.5"
                data-testid="lien-retour-accueil">
            <ArrowLeft size={15} /> Retour à l'accueil
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="font-serif font-bold text-3xl mb-8">{title}</h1>
        <div className="space-y-6 text-sm text-stone-700 leading-relaxed">{children}</div>
      </main>
    </div>
  );
}

function Section({ titre, children }) {
  return (
    <section>
      <h2 className="font-serif font-semibold text-lg text-[#221F1A] mb-2">{titre}</h2>
      {children}
    </section>
  );
}

export function Cgv() {
  return (
    <LegalLayout title="Conditions Générales de Vente" testid="page-cgv">
      <Section titre="1. Éditeur du service">
        <p>
          Mastoras est édité par {EDITEUR.nom}, {EDITEUR.forme} — SIREN {EDITEUR.siren} —
          SIRET {EDITEUR.siret} — {EDITEUR.adresse} — contact : {EDITEUR.email}
          (ci-après « l'Éditeur »).
        </p>
      </Section>
      <Section titre="2. Objet">
        <p>
          Mastoras est une application web (SaaS) destinée à tous les artisans : création de devis et
          factures, gestion de stock, suivi clients et agenda. L'utilisation du service implique
          l'acceptation pleine et entière des présentes conditions.
        </p>
      </Section>
      <Section titre="3. Abonnement et essai gratuit">
        <p>
          Le service est proposé au tarif unique de <strong>25 € HT par mois</strong> (TVA applicable en
          sus, soit 30 € TTC en France). Chaque nouvelle entreprise bénéficie d'un{" "}
          <strong>essai gratuit de 14 jours</strong>, avec accès complet aux fonctionnalités.
          L'enregistrement d'un moyen de paiement (carte bancaire ou prélèvement SEPA) est demandé au
          démarrage de l'essai ; <strong>aucun prélèvement n'est effectué pendant ces 14 jours</strong>.
          À l'issue de l'essai, l'abonnement démarre automatiquement sauf résiliation avant son terme ;
          les données de l'entreprise sont conservées en toutes circonstances.
        </p>
      </Section>
      <Section titre="4. Paiement et renouvellement">
        <p>
          L'abonnement est payable mensuellement par carte bancaire via notre prestataire de paiement
          sécurisé Stripe. Il est renouvelé automatiquement par période d'un mois. Une facture
          conforme est émise par Stripe à chaque échéance. En cas d'échec de paiement, l'accès peut
          être suspendu après les relances automatiques de Stripe.
        </p>
      </Section>
      <Section titre="5. Résiliation">
        <p>
          L'abonnement est sans engagement : il peut être résilié à tout moment depuis l'espace « Mon
          Entreprise » (portail de facturation Stripe). La résiliation prend effet à la fin de la
          période mensuelle en cours ; aucun remboursement au prorata n'est dû.
        </p>
      </Section>
      <Section titre="6. Données et disponibilité">
        <p>
          Les données saisies restent la propriété de l'entreprise utilisatrice. L'Éditeur s'engage à
          une obligation de moyens pour assurer la disponibilité et la sécurité du service. Le service
          fonctionne partiellement hors-ligne ; la synchronisation s'effectue dès le retour du réseau.
        </p>
      </Section>
      <Section titre="7. Responsabilité">
        <p>
          Mastoras est un outil d'aide à la gestion : l'utilisateur reste seul responsable de la
          conformité de ses devis et factures (mentions légales, TVA, garanties) et de la sauvegarde
          des pièces originales. L'Éditeur ne saurait être tenu responsable d'un préjudice indirect
          (perte d'exploitation, de clientèle, etc.).
        </p>
      </Section>
      <Section titre="8. Droit applicable">
        <p>
          Les présentes CGV sont soumises au droit français. Tout litige sera soumis aux tribunaux
          compétents du ressort du siège de l'Éditeur, sauf disposition légale contraire.
        </p>
      </Section>
      <p className="text-xs text-stone-500">Dernière mise à jour : septembre 2026.</p>
    </LegalLayout>
  );
}

export function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" testid="page-confidentialite">
      <Section titre="1. Responsable de traitement">
        <p>
          {EDITEUR.nom}, {EDITEUR.adresse} — {EDITEUR.email} — est responsable du traitement des
          données collectées via Mastoras.
        </p>
      </Section>
      <Section titre="2. Données collectées">
        <p>
          Compte : nom, email, mot de passe (chiffré), raison sociale et SIRET. Données métier
          saisies par l'utilisateur : clients, chantiers, devis, factures, articles de stock, messages,
          rendez-vous et photos. Données de paiement : traitées directement par Stripe, jamais stockées
          par Mastoras.
        </p>
      </Section>
      <Section titre="3. Finalités">
        <p>
          Fourniture du service (devis, factures, stock, agenda, notifications), gestion de
          l'abonnement, envoi des emails transactionnels (devis, relances, rappels de rendez-vous) et
          amélioration du service. Aucune donnée n'est revendue ni utilisée à des fins publicitaires.
        </p>
      </Section>
      <Section titre="4. Sous-traitants">
        <p>
          Hébergement : infrastructure cloud professionnelle (données chiffrées au repos en
          AES-256, sauvegardes automatiques), pouvant être située hors de l'Union européenne.
          Paiement : Stripe. Emails transactionnels : Resend. Ces prestataires traitent les données
          selon leurs propres engagements de sécurité et de protection des données.
        </p>
      </Section>
      <Section titre="5. Durée de conservation">
        <p>
          Les données sont conservées pendant toute la durée de l'abonnement. En cas de résiliation ou
          d'expiration de l'essai, elles sont conservées puis supprimées sur demande écrite à
          {" "}{EDITEUR.email}.
        </p>
      </Section>
      <Section titre="6. Vos droits">
        <p>
          Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de
          portabilité et d'opposition concernant vos données. Exercez-les par email à {EDITEUR.email}.
          Vous pouvez également saisir la CNIL (cnil.fr) en cas de réclamation.
        </p>
      </Section>
      <Section titre="7. Cookies et stockage local">
        <p>
          Mastoras utilise uniquement des cookies strictement nécessaires au fonctionnement du service
          (session d'authentification, exemptés de consentement selon la CNIL) ainsi que le stockage local
          du navigateur pour le mode hors-ligne. Aucun cookie publicitaire ou de mesure d'audience tiers
          n'est déposé. Si de tels outils sont ajoutés à l'avenir, ils ne seront activés qu'après votre
          accord via le bandeau de consentement affiché lors de votre première visite ; vous pouvez
          modifier votre choix à tout moment grâce au lien « Gérer les cookies » ci-dessous, également
          présent dans le pied de page du site.
        </p>
        <button type="button" onClick={() => window.tarteaucitron?.userInterface?.openPanel?.()}
                className="mt-2 text-[#B5762A] hover:text-[#D9A461] text-sm font-semibold underline underline-offset-2"
                data-testid="lien-gerer-cookies">
          Gérer les cookies
        </button>
      </Section>
      <p className="text-xs text-stone-500">Dernière mise à jour : octobre 2026.</p>
    </LegalLayout>
  );
}
